function collaborationSlider() {
    const $slideshow = $('.collaborations-row');

    if($slideshow.length > 0) {
        $slideshow.slick({
            dots: true,
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 600,
            autoplay: true,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 770,
                    settings: 'unslick'
                }
            ]
        });
    }
}

$(document).ready(function() {
    collaborationSlider();
});
